module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAUVBMVEUAAABrdIpqdIprc4pqc4lqcoprc4pqc4plbIlpcIdob4locYdVVYBqc4lqc4hpcYpqcoprc4pqcohqaoBqcolqdIlrcohqc4locopgcIBrdIobJhOAAAAAGnRSTlMAv3+g4GDqrhpGLSQG83VizGs3DLqTklRMEA5JWTgAAACLSURBVBjTbc7ZDoQgDIXhslh2cHTWvv+DTg5qYgj/RUu+m0Lzku498N4vdKyQBKJW/InK9CULNRH1GTGyvNkMSN7skZcBUV0nGLhfLxbhOvq54Z+TcjXolYjIr/nAryjEDijxwEX6MgrTtglq6+MzDZiVdcLbHaHaiug79oJoDIuKo7OtX9Koepr2B9PQBerHagn4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/index/images/appIcon/jxhd.png
// module id = Yq+T
// module chunks = 57